<template>
  <div>
    <div
      class="table-scroll-slider"
      v-if="show && hasScrollbar && showIcon == false"
    >
      <input
        type="range"
        :min="0"
        :max="maxScroll"
        v-model.number="scrollPosition"
        class="custom-range"
        @input="onSliderInput"
      />
      <i
        class="el-icon-bottom-right"
        @click="close"
        style="width: 10px; height: 10px; margin-left: 10px"
      ></i>
    </div>
    <div v-if="showIcon" @click="selectIcon" class="icon">
      <i class="el-icon-top-left"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableScrollSlider",
  props: {
    // 要控制的表格实例或 DOM 元素
    tableRef: {
      // required: true,
      // validator: value => {
      //   return (
      //     value && (typeof value === "object" || typeof value === "string")
      //   );
      // }
    },
  },
  watch: {
    tableRef: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.initScroll();
          });
        }
      },
    },
  },
  data() {
    return {
      showIcon: false,
      scrollBottomDistance: 0,
      scrollPosition: 0,
      show: true,
      hasScrollbar: true, // 是否存在滚动条的状态
      tableHeight: 0,
      maxScroll: 0,
    };
  },
  mounted() {
    window.addEventListener("resize", this.initScroll);
    window.addEventListener("scroll", this.handleScroll);
    // 初始化时检查一次
    // this.checkScrollbar();
    // 监听滚动事件，当用户滚动页面时触发
    window.addEventListener("scroll", this.checkScrollbar);

    // 监听窗口大小变化，当窗口大小发生变化时触发
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initScroll);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    close() {
      this.showIcon = true;
    },
    selectIcon() {
      this.showIcon = false;
    },
    checkScrollbar() {
      // 判断文档内容的高度是否大于视窗高度
      if (document.documentElement.scrollHeight > window.innerHeight) {
        this.hasScrollbar = true;
      } else {
        this.hasScrollbar = false;
      }

      // console.log(document.body.scrollHeight);
      // console.log(document.documentElement.scrollHeight);
      // console.log(window.innerHeight + 10);
      // console.log(this.hasScrollbar);
    },
    handleResize() {
      // 当窗口大小改变时重新检查
      this.checkScrollbar();
    },
    handleScroll() {
      // 计算滚动距离
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.documentElement.scrollHeight || document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );
      this.scrollBottomDistance = documentHeight - (scrollTop + windowHeight);
      if (this.scrollBottomDistance < 100) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    initScroll() {
      const wrapper = this.getTableWrapper();
      if (!wrapper) return;

      this.maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      this.scrollPosition = wrapper.scrollLeft;
    },
    getTableWrapper() {
      let tableEl = null;

      // 如果传入的是字符串，则查找对应 ID 的元素
      if (typeof this.tableRef === "string") {
        tableEl = document.getElementById(this.tableRef);
      } else if (this.tableRef.$el) {
        // 如果是 Vue 组件实例（如 ref）
        tableEl = this.tableRef.$el;
      }

      if (!tableEl) return null;

      // 找到 Element UI 表格的 body-wrapper 容器
      return tableEl.querySelector(".el-table__body-wrapper");
    },
    onSliderInput(event) {
      const targetScrollLeft = parseInt(event.target.value, 10);
      const wrapper = this.getTableWrapper();
      if (!wrapper) return;

      wrapper.scrollLeft = targetScrollLeft;
      this.scrollPosition = targetScrollLeft;
    },
    onTableScroll() {
      const wrapper = this.getTableWrapper();
      if (!wrapper) return;

      this.scrollPosition = wrapper.scrollLeft;
      this.maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
    },
  },
};
</script>

<style scoped>
.table-scroll-slider {
  width: 50%;
  position: fixed;
  bottom: 10%;
  left: 30%;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.1);
  /* height: 30px; */
  cursor: pointer;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 20px;
  display: flex;
  align-items: center;
}
.icon {
  position: fixed;
  bottom: 5%;
  right: 10px;
  z-index: 999;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background: #fff;
  text-align: center;
  line-height: 30px;
  box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.2);
}
/* input[type="range"] {
  width: 100%;
  margin-top: 7px;
  cursor: pointer;
} */
.custom-range {
  -webkit-appearance: none; /* 移除默认样式 */
  appearance: none;
  width: 100%;
  background: #fff;
  height: 6px;
}

/* 滑动轨道（Track） */
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  background: #fff;
  border-radius: 5px;
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  cursor: pointer;
}

.custom-range::-moz-range-track {
  width: 100%;
  height: 6px;
  background: #fff;
  border-radius: 5px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

/* 滑块（Thumb） */
.custom-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  margin-top: -8px; /* 垂直居中 */
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
  border: 1px solid #ccc;
}
</style>
